import { createContext, useContext, useState, type ReactNode } from "react";

export interface ForgeDocument {
  forgeId: string;
  title: string;
  researchQuestion: string;
  projectId: string;
  projectName: string;
  siblingForges: Array<{ id: string; title: string }>;
}

interface DocumentCtxValue {
  doc: ForgeDocument | null;
  setDoc: (doc: ForgeDocument) => void;
}

const DocumentCtx = createContext<DocumentCtxValue | null>(null);

export function DocumentCtxProvider({ children }: { children: ReactNode }) {
  const [doc, setDoc] = useState<ForgeDocument | null>(null);
  return (
    <DocumentCtx.Provider value={{ doc, setDoc }}>
      {children}
    </DocumentCtx.Provider>
  );
}

export function useDocumentCtx(): DocumentCtxValue {
  const ctx = useContext(DocumentCtx);
  if (!ctx) throw new Error("useDocumentCtx: missing DocumentCtxProvider");
  return ctx;
}
